import axios from "axios";
import { Constants } from '../utils/Constants';

export function get(id) {
	return axios.get(`${Constants.baseUrlV2}/limpeza-checklist/${id}`);
}

function transformData(payload){
	const formData = new FormData();
	Object.keys(payload).forEach(key => {
		if (key === 'foto_veiculo' && payload[key]) {
			formData.append(key, payload[key]);
		} else {
			buildFormData(formData, payload[key], key);
		}
	});

	return formData;
}

function buildFormData(formData, data, parentKey) {
	if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
		Object.keys(data).forEach(key => {
			buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
		});
	} else {
		const value = data == null ? '' : data;
		formData.append(parentKey, value);
	}
}

export function create(payload) {
	const formData = transformData(payload);
	return axios.post(`${Constants.baseUrlV2}/limpeza-checklist`, formData);
}

export function update(id, payload) {
	const formData = transformData(payload);
	formData.append('_method', 'PUT');
	return axios.post(`${Constants.baseUrlV2}/limpeza-checklist/${id}`, formData);
}

export function renew(id, payload) {
	return axios.post(`${Constants.baseUrlV2}/limpeza-checklist/renew/${id}`, {lcr_motivo: payload.lcr_motivo});
}

export function validateCreate(payload) {
	const formData = transformData(payload);
	return axios.post(`${Constants.baseUrlV2}/limpeza-checklist/validate-create`, formData);
}

export function validateUpdate(id, payload) {
	const formData = transformData(payload);
	formData.append('_method', 'PUT');
	return axios.post(`${Constants.baseUrlV2}/limpeza-checklist/validate-update/${id}`, formData);
}

export function validateFracionado(id) {
	return axios.post(`${Constants.baseUrlV2}/limpeza-checklist/validate-fracionado/${id}`);
}

export function search(events) {
	return axios.post(`${Constants.baseUrlV2}/limpeza-checklist/search`, events);
}

export function dashboardByPeriodo(form, id) {
	return axios.get(`${Constants.baseUrlV2}/limpeza-checklist/dashboard/periodo`);
}

export function destroy(id, payload) {
	return axios.post(`${Constants.baseUrlV2}/limpeza-checklist/delete/${id}`, {lch_justificativa: payload.lch_justificativa});
}

export function listLimpezaChecklistPergunta(){
	return axios.get(`${Constants.baseUrlV2}/limpeza-checklist/pergunta`);
}

export function listLimpezaChecklistPagamento(){
	return axios.get(`${Constants.baseUrlV2}/limpeza-checklist/tipo-pagamento`);
}

export function listLimpezaTipoLaudo(){
	return axios.get(`${Constants.baseUrlV2}/limpeza-checklist/tipo-laudo`);
}

export function listLimpezaCondicaoGeral(){
	return axios.get(`${Constants.baseUrlV2}/limpeza-checklist/condicao-geral`);
}

export function listLimpezaCondicaoLimpeza(){
	return axios.get(`${Constants.baseUrlV2}/limpeza-checklist/condicao-limpeza`);
}

export function exportXls(filters) {
	return axios.post(`${Constants.baseUrlV2}/limpeza-checklist/export/xls`, filters, {
		responseType: 'blob'
	});
}

export const onboardingCaminhoneiroChecklist = (data) => {
	return axios.post(`${Constants.baseUrlV2}/limpeza-checklist/onboarding-caminhoneiro`, data)
};

export const updateCaminhoneiroChecklist = (id, data) => {
	return axios.put(`${Constants.baseUrlV2}/limpeza-checklist/update-caminhoneiro/${id}`, data)
};

export const verify = (code) => {
	return axios.get(`${Constants.baseUrlV2}/limpeza-checklist/verify/${code}`)
};

export function placasDisponiveis(originalChecklistId) {
	return axios.get(`${Constants.baseUrlV2}/limpeza-checklist/fracionado/placas/${originalChecklistId}`);
}